module.exports = __webpack_public_path__ + "static/media/mostru-verde-claro.dfdbf8d9.svg";